module.exports = __webpack_public_path__ + "img/index-kinds-news.e0511e5e.png";